// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1Ntp-","footer":"ModalFilter_footer__2tFNN"};